import * as tokens from '../../../../../tokens/color.light.generated.js';
export const componentColorLight = {
    color: {
        feedback: {
            progressIndicator: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        inverted: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_INVERTED_LIGHT,
                        range: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_RANGE_DEFAULT_LIGHT
                        }
                    }
                },
                monochrome: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                },
                inverted: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                },
                colored: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_COLORED_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_COLORED_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                }
            },
            infoBox: {
                foreground: {
                    icon: {
                        success: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_SUCCESS_LIGHT,
                        error: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_ERROR_LIGHT,
                        warning: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_WARNING_LIGHT,
                        default: tokens.CMP_COLOR_FEEDBACK_INFOBOX_FOREGROUND_ICON_DEFAULT_LIGHT
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_FEEDBACK_INFOBOX_SURFACE_FILL_DEFAULT_LIGHT
                    }
                }
            },
            notificationForeground: {
                icon: {
                    default: tokens.CMP_COLOR_FEEDBACK_NOTIFICATION_FOREGROUND_ICON_DEFAULT_LIGHT
                }
            }
        },
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_LIGHT
                }
            },
            iconButton: {
                primary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                },
                secondary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                },
                tertiary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                }
            }
        },
        navigation: {
            textLink: {
                foreground: {
                    disabled: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DISABLED_LIGHT,
                    default: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_LIGHT,
                    interactive: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_INTERACTIVE_LIGHT
                }
            }
        },
        forms: {
            extendedSelection: {
                surface: {
                    stroke: {
                        error: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_ERROR_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DISABLED_LIGHT,
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_INTERACTIVE_LIGHT
                    }
                }
            },
            slider: {
                surface: {
                    handle: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DISABLED_LIGHT
                    },
                    track: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_TRACK_DEFAULT_LIGHT
                    },
                    steps: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_STEPS_DEFAULT_LIGHT
                    },
                    progress: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DISABLED_LIGHT,
                        error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_ERROR_LIGHT
                    }
                }
            },
            toggle: {
                inactive: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DISABLED_LIGHT,
                        handle: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_HANDLE_DEFAULT_LIGHT
                        }
                    }
                },
                active: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DISABLED_LIGHT
                    }
                }
            },
            listItem: {
                surface: {
                    fill: {
                        interactive: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_INTERACTIVE_LIGHT
                    }
                }
            }
        },
        ui: {
            avatar: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        secondary: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_TEXT_SECONDARY_LIGHT
                    },
                    icons: {
                        default: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_DEFAULT_LIGHT,
                        hover: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_HOVER_LIGHT,
                        pressed: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_PRESSED_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_AVATAR_FOREGROUND_ICONS_DISABLED_LIGHT
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_DISABLED_LIGHT,
                        pressed: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_PRESSED_LIGHT,
                        hover: tokens.CMP_COLOR_UI_AVATAR_SURFACE_FILL_HOVER_LIGHT
                    }
                }
            },
            accordion: {
                surface: {
                    pressed: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_PRESSED_LIGHT
                }
            },
            tag: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TAG_SURFACE_FILL_DEFAULT_LIGHT
                    }
                },
                selected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DISABLED_LIGHT
                        }
                    }
                },
                unselected: {
                    surface: {
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DISABLED_LIGHT
                        },
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DISABLED_LIGHT
                        }
                    }
                }
            },
            skeleton: {
                surface: {
                    fill: tokens.CMP_COLOR_UI_SKELETON_SURFACE_FILL_LIGHT
                }
            },
            value: {
                foreground: {
                    label: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_LABEL_LIGHT,
                    caption: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_CAPTION_LIGHT
                }
            },
            table: {
                foreground: {
                    text: {
                        title: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_TITLE_DEFAULT_LIGHT
                        },
                        headline: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_HEADLINE_DEFAULT_LIGHT
                        },
                        copy: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_COPY_DEFAULT_LIGHT
                        }
                    },
                    divider: {
                        default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TABLE_SURFACE_FILL_DEFAULT_LIGHT
                    }
                }
            },
            productTile: {
                foreground: {
                    caption: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_TILE_FOREGROUND_CAPTION_DEFAULT_LIGHT
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map